import { TApplicationState } from '../../types/redux';

export const selectRecommendations = (state: TApplicationState) => {
  return state.newbuildingRecommendations.newbuildings;
};
